import { useEffect } from 'react';
import {
	setAuthToken,
	setSnackbarMessage,
	setSnackbarSeverity,
} from 'reducers/global.reducer';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { BrowserRouter } from 'react-router-dom';

import { constants } from 'utils/constants';
import { useMsalAuth } from 'customHooks/useMsalAuth';
import { loginRequest } from 'authConfig';
import Router from '../../Router';

export const MSAL_VALIDATION_BODY = {
	clientId: 'sampleRXapp',
	clientSecret: 'my-secret-token-to-change-in-production',
	grantType: 'password',
	oktaLoginIssuer:
		'https://login.microsoftonline.com/8bc97f9a-ea86-472e-8ab7-19db58c4c8af/v2.0',
};

const Home = () => {
	const dispatch = useAppDispatch();
	const authToken = useAppSelector((s) => s.global.authToken); // JWT TOKEN
	const { accounts, isAuthenticated, instance, logout } = useMsalAuth();

	useEffect(() => {
		if (isAuthenticated) {
			getMsalToken();
		}
	}, [dispatch, isAuthenticated]);

	const getMsalToken = async () => {
		await instance
			.acquireTokenSilent({
				...loginRequest,
				account: accounts[0],
			})
			.then((response) => {
				getAfsToken(response?.accessToken);
			})
			.catch((err) => {
				console.log('error while getting msal token', err);
				logout();
			});
	};

	const getAfsToken = (accessToken: any) => {
		fetch(`${constants('afsUrl')}/api/validate-okta-token`, {
			method: 'POST',
			headers: {
				Authorization: `Bearer ${accessToken}`,
				'X-Domain': 'NURTURE_FARM',
				'CONTENT-TYPE': 'application/json',
			},
			body: JSON.stringify(MSAL_VALIDATION_BODY),
		})
			.then((res) => res.json())
			.then((data) => {
				// TODO: handle 500 response here
				// eslint-disable-next-line no-undef
				localStorage.setItem(
					'token',
					JSON.stringify(data?.oauthResponseDTO?.access_token),
				);
				// eslint-disable-next-line no-undef
				localStorage.setItem(
					'refreshToken',
					JSON.stringify(data?.oauthResponseDTO?.refresh_token),
				);
				// eslint-disable-next-line no-undef
				if (data?.login || data?.firstName) {
					localStorage.setItem(
						'ugdn',
						JSON.stringify(
							data?.login
								? getUgdn(data?.login)
								: getUgdn(data?.firstName),
						),
					);
				}

				dispatch(
					setAuthToken(
						JSON.stringify(
							data?.oauthResponseDTO?.access_token ?? '',
						),
					),
				);
			})
			.catch(() => {
				dispatch(setSnackbarSeverity('error'));
				dispatch(
					setSnackbarMessage(
						'Something went wrong while fetching user details. Please re-login!',
					),
				);
			});
	};

	const getUgdn = (ugdnString: any) => {
		const index = ugdnString.indexOf('@');
		const ugdnSubString =
			index !== -1 ? ugdnString.slice(0, index) : ugdnString;
		return Number(ugdnSubString);
	};

	return (
		<div>
			{authToken.length > 0 ? (
				<BrowserRouter>
					<Router />
				</BrowserRouter>
			) : null}
		</div>
	);
};

export default Home;
